export default __webpack_public_path__ + "static/media/icn-file.91557435.svg";